<form #f="ngForm">

  <div class="contenedor_cabecera">
    <div class="contenedor_cancel"></div>
    <div class="cabecera">
      <p>{{"events.formEditTitle" | translate}}</p>
    </div>
    <div id="cerrar_busqueda" class="contenedor_cancel">
      <button (click)="onClose()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>

  <div class="contenedor_formulario">

    <!-- Campo: name (nombre del evento) -->
    <div class="campo_formulario">
      <p>
        <label>{{"events.formName" | translate}}</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Nombre del evento" type="text" [(ngModel)]="nuevoItem.name" name="name" required
          #nameCtrl="ngModel">
        @if(name_control.invalid){
        <mat-error>{{getErrorMessage_name()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: price (precio de la entrada) -->
    <div class="campo_formulario">
      <p>
        <label>Precio de la entrada</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Precio de la entrada" type="number" min="0" [(ngModel)]="nuevoItem.price"
          name="price" required #priceCtrl="ngModel">
        @if(price_control.invalid){
        <mat-error>{{getErrorMessage_price()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: amount (número de entradas a la venta) -->
    <div class="campo_formulario">
      <p>
        <label>Número de entradas a la venta</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Número de entradas a la venta" type="number" min="0" [(ngModel)]="nuevoItem.amount"
          name="amount" #amountCtrl="ngModel">
        @if(amount_control.invalid){
        <mat-error>{{getErrorMessage_amount()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: minTickets (mínimo número de entradas por compra) -->
    <div class="campo_formulario">
      <p>
        <label>Mínimo número de entradas por compra</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Mínimo número de entradas por compra" type="number" min="0"
          [(ngModel)]="nuevoItem.minTickets" name="minTickets" #minTicketsCtrl="ngModel">
        @if(minTickets_control.invalid){
        <mat-error>{{getErrorMessage_minTickets()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: maxTickets (máximo número de entradas por compra) -->
    <div class="campo_formulario">
      <p>
        <label>Máximo número de entradas por compra</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Máximo número de entradas por compra" type="number" min="0"
          [(ngModel)]="nuevoItem.maxTickets" name="maxTickets" #maxTicketsCtrl="ngModel">
        @if(maxTickets_control.invalid){
        <mat-error>{{getErrorMessage_maxTickets()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: maxPerUser (máximo número de entradas por persona) -->

    <div class="campo_formulario">
      <p>
        <label>Máximo número de entradas por persona</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Máximo número de entradas por usuario" type="number" min="0"
          [(ngModel)]="nuevoItem.maxPerUser" name="maxPerUser" #maxPerUserCtrl="ngModel">
        @if(maxPerUser_control.invalid){
        <mat-error>{{getErrorMessage_maxPerUser()}}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campo: description (descripción del evento) -->
    <div class="campo_formulario">
      <p>
        <label>Descripción del evento</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <textarea matInput placeholder="Descripción del evento" [(ngModel)]="nuevoItem.description" name="description"
          rows="4" #descriptionCtrl="ngModel"></textarea>
      </mat-form-field>
    </div>

    <!-- Campo: location (ubicación del evento) -->
    <div class="campo_formulario">
      <p>
        <label>Ubicación del evento</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Ubicación del evento" type="text" [(ngModel)]="nuevoItem.location" name="location"
          #locationCtrl="ngModel">
      </mat-form-field>
    </div>

    <!-- Campo: iniDate (fecha y hora de inicio del evento) -->
    <div class="campo_formulario">
      <p>
        <label>Fecha y hora de inicio del evento</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Fecha y hora de inicio" type="datetime-local" [(ngModel)]="nuevoItem.iniDate"
          name="iniDate" #iniDateCtrl="ngModel">
      </mat-form-field>
    </div>

    <!-- Campo: endDate (fecha y hora de finalización del evento) -->
    <div class="campo_formulario">
      <p>
        <label>Fecha y hora de finalización del evento</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Fecha y hora de finalización" type="datetime-local" [(ngModel)]="nuevoItem.endDate"
          name="endDate" #endDateCtrl="ngModel">
      </mat-form-field>
    </div>

    <!-- Campo: iniSale (fecha y hora de apertura de venta) -->
    <div class="campo_formulario">
      <p>
        <label>Fecha y hora de apertura de venta de entradas</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Fecha y hora de apertura de venta" type="datetime-local"
          [(ngModel)]="nuevoItem.iniSale" name="iniSale" #iniSaleCtrl="ngModel">
      </mat-form-field>
    </div>

    <!-- Campo: endSale (fecha y hora de cierre de venta) -->
    <div class="campo_formulario">
      <p>
        <label>Fecha y hora de cierre de venta de entradas</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <input matInput placeholder="Fecha y hora de cierre de venta" type="datetime-local"
          [(ngModel)]="nuevoItem.endSale" name="endSale" #endSaleCtrl="ngModel">
      </mat-form-field>
    </div>

    <!-- Campo: image (imagen del evento) -->
    <div class="campo_formulario">
      <label class="primary-color">{{ 'forms.image' | translate }}</label>
      <div style="width: 100%">
        <div style="width: 100%;justify-content: center">
          @if(imgURL){
          <img [src]="imgURL" height="1600" width="1132" class="imagen" alt="">
          }
          @if(imageError){
          <ng-container>{{ imageError }}</ng-container>
          }
          <div class="custom-input-file tertiary-background">
            <input #file class="input-file" id="event-img" type="file" value="event-img" accept=".jpg,.png,.svg,.jpeg"
              (change)="preview($event)" name="event-img">{{ 'forms.changeImage' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Campo: eventUserCategories (categorías de usuarios) -->
    <div class="campo_formulario" style="margin-top: 15px;">
      <p>
        <label>Asociar tipo de asistente</label>
      </p>
      <mat-form-field class="mat-form-field_personalizado" appearance="outline">
        <mat-select [(ngModel)]="nuevoItem.categories" name="categories" multiple #categoriesCtrl="ngModel">
          @for (category of eventUserCategories; track category) {
          <mat-option [value]="category">
            {{ category }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Campo: isNominative (activar formulario dinámico) -->
    <div class="campo_formulario">
      <div style="display: flex; align-items: center; padding: 10px 0;">
        <mat-checkbox [(ngModel)]="isNominative" [ngModelOptions]="{standalone: true}">
          <label style="font-weight: 500; font-size: 16px; margin-left: 8px;">Entrada nominativa</label>
        </mat-checkbox>
      </div>
    </div>

    <!-- Formulario dinámico para campos adicionales -->
    @if(isNominative){
    <div class="campo_formulario" style="margin: 15px 0;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin: 15px 0;">
        <label style="font-weight: 500; font-size: 16px;">{{ 'vouchers.dynamicFormForUsers' | translate }}</label>
      </div>

      <button type="button" (click)="addFormField()"
        style="padding: 8px; background-color: #1976d2; color: white; border: none; border-radius: 4px; cursor: pointer; margin-bottom: 10px;">
        <mat-icon class="add" svgIcon="add" style="vertical-align: middle; font-size: 18px;"></mat-icon>
        {{ 'vouchers.addField' | translate }}
      </button>

      @if(formData.length === 0){
      <div
        style="padding: 20px; text-align: center; color: #666; background-color: #f5f5f5; border-radius: 4px; margin-bottom: 15px;">
        {{ 'vouchers.noFields' | translate }}
      </div>
      }

      @for(field of formData; track $index){
      <div
        style="margin-bottom: 15px; padding: 15px; border: 1px solid #ddd; border-radius: 4px; background-color: #fafafa;">

        @if(!isEditingField($index)){
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="flex: 1;">
            <div style="font-weight: 500; margin-bottom: 25px;">{{ field.webName || 'Sin nombre' }}</div>
            <div style="font-size: 12px; color: #666; margin-bottom: 10px;">
              <span>{{ 'vouchers.fieldName' | translate }}: <strong>{{ field.name }}</strong></span> |
              <span>{{ 'vouchers.fieldType' | translate }}: <strong>{{ field.type }}</strong></span> |
              <span>{{ 'vouchers.required' | translate }}: <strong>{{ field.required ? 'Sí' : 'No' }}</strong></span>
            </div>
            @if(field.type === 'select' && field.options && field.options.length > 0){
            <div style="font-size: 12px; color: #666; margin-top: 5px;">
              <div style="font-weight: 500; margin: 20px 0 12px 0;">{{ 'vouchers.selectOptions' | translate }}:</div>
              <div style="display: flex; flex-wrap: wrap; gap: 5px;">
                @for( option of field.options; track $index){
                <span style="background-color: #e3f2fd; padding: 4px 8px; border-radius: 4px; font-size: 11px;">
                  {{ option.name }}
                </span>
                }
              </div>
            </div>
            }

          </div>
          <div>
            <button type="button" (click)="editFormField($index)"
              style="margin-right: 8px; padding: 6px 12px; background-color: #ff9800; color: white; border: none; border-radius: 4px; cursor: pointer;">
              {{ 'forms.edit' | translate }}
            </button>
            <button type="button" (click)="deleteFormField($index)"
              style="padding: 6px 12px; background-color: #f44336; color: white; border: none; border-radius: 4px; cursor: pointer;">
              {{ 'forms.delete' | translate }}
            </button>
          </div>
        </div>
        }

        @if(isEditingField($index)){
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{ 'vouchers.fieldName' | translate }}</mat-label>
            <input matInput [(ngModel)]="field.name" placeholder="Ej: name, surname"
              [ngModelOptions]="{standalone: true}">
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{ 'vouchers.webName' | translate }}</mat-label>
            <input matInput [(ngModel)]="field.webName" placeholder="Ej: Nombre, Apellidos"
              [ngModelOptions]="{standalone: true}">
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>{{ 'vouchers.fieldType' | translate }}</mat-label>
            <mat-select [(ngModel)]="field.type" (selectionChange)="onFieldTypeChange($index)"
              [ngModelOptions]="{standalone: true}">
              @for(type of fieldTypes; track $index){
              <mat-option [value]="type">
                {{ type }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div style="display: flex; align-items: center; padding-top: 8px;">
            <mat-checkbox [(ngModel)]="field.required" [ngModelOptions]="{standalone: true}">
              {{ 'vouchers.required' | translate }}
            </mat-checkbox>
          </div>

          <!-- Sección de opciones para campos select -->
          @if(field.type === 'select'){
          <div
            style="grid-column: 1 / -1; margin-top: 15px; padding: 15px; background-color: #f9f9f9; border-radius: 4px; border: 1px solid #ddd;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <label style="font-weight: 500; font-size: 14px;">Opciones del select</label>
              <button type="button" (click)="addOption($index)"
                style="width: 110px; padding: 6px 12px; background-color: #1976d2; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                {{ 'vouchers.addOption' | translate }}
              </button>
            </div>

            @if(!field.options || field.options.length === 0){
            <div
              style="padding: 20px; text-align: center; color: #666; font-size: 12px; background-color: #fff; border-radius: 4px; margin-bottom: 10px;">
              {{ 'vouchers.noOptions' | translate }}
            </div>
            }

            @for(option of field.options; track $index){
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
              <mat-form-field appearance="outline" style="flex: 1;">
                <mat-label>{{ 'vouchers.optionName' | translate }}</mat-label>
                <input matInput [(ngModel)]="option.name" placeholder="Ej: cóctel, cerveza, etc."
                  [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <button type="button" (click)="removeOption($index, $index)"
                style="width: 110px; padding: 6px 12px; background-color: #f44336; color: white; border: none; border-radius: 4px; cursor: pointer;">
                {{ 'forms.delete' | translate }}
              </button>
            </div>
            }


          </div>
          }


          <div style="grid-column: 1 / -1; display: flex; justify-content: flex-end; gap: 10px; margin-top: 10px;">
            <button type="button" (click)="saveFormField($index)"
              style="padding: 8px 16px; background-color: #4caf50; color: white; border: none; border-radius: 4px; cursor: pointer;">
              {{ 'forms.save' | translate }}
            </button>
            <button type="button" (click)="cancelEditFormField()"
              style="padding: 8px 16px; background-color: #757575; color: white; border: none; border-radius: 4px; cursor: pointer;">
              {{ 'forms.cancel' | translate }}
            </button>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>

  <div class="contenedor_botones_outside">
    <div class="contenedor_botones_inside" id="contenedor_filtros_inside">
      <button id="delete_button" class="button borrar" (click)="onDelete()" style="cursor:pointer;">
        {{"events.formEditDelete" | translate}}
      </button>
      <br>
      <button id="edit_button" (click)="onSubmit(f)" class="button" [disabled]="!f.valid" style="cursor:pointer;">
        {{"events.formEditChanges" | translate}}
      </button>
    </div>
  </div>

  @if (showAlert) {
  <div
    style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); width: 90%; max-width: 600px; z-index: 9999;">
    <bracelit-alert [type]="alertType" (closed)="showAlert = false">
      {{ alertMessage }}
    </bracelit-alert>
  </div>
  }

</form>